<template>
    <form id="printJS-form">
        <div id="printer1">
        </div>
    </form>
</template>
<script>
import printJS from 'print-js'
export default {
    name: 'print',
    props: {
        // html: {
        //     type: String,
        //     default: ""
        // }
    },
    watch: {
        // html(val) {
        //     if (val) {
        //         this.setBodyHtml(val);
        //     }
        // }
    },
    created() {
    },
    beforeDestroy() {

    },
    data() {
        return {

        }
    },
    methods: {
        wsFunc(e) {
            console.log(1111)
            console.log(e)
        },
        setBodyHtml2(html) {
            const doc = document.getElementById('printer1')
            doc.innerHTML = html
            doc.style.display = "block";
            document.querySelectorAll('p').forEach(item => { item.style.fontSize = "12px", item.style.lineHeight = "23px" })
            document.querySelectorAll('.ivu-table-tbody span').forEach(item => { item.style.fontSize = "12px" })
            document.querySelectorAll('.ivu-table-summary .ivu-table-tbody span').forEach(item => { item.style.fontSize = "14px", item.style.fontWeight = "800" })
            document.querySelectorAll('h2').forEach(item => { item.style.lineHeight = "50px";item.style.height = "50px" })
            document.querySelectorAll('h3').forEach(item => { item.style.lineHeight = "40px";item.style.height = "40px" })
            document.querySelectorAll('h4').forEach(item => { item.style.lineHeight = "30px";item.style.height = "30px" })
            document.querySelectorAll('h5').forEach(item => { item.style.lineHeight = "30px";item.style.height = "30px" })
            document.querySelectorAll('h6').forEach(item => { item.style.lineHeight = "60px";item.style.height = "60px" })
            let imgRules = document.querySelector('.img-rules')
            imgRules.style.height = "150px"
            imgRules.style.width = "150px"
            imgRules.style.left = "50px"
            imgRules.style.bottom = "20px"
            imgRules.style.position = "relative"
            //console.log(imgRules)
            printJS({
                printable: 'printJS-form',
                type:'html',
                targetStyles:['*'],//继承页面要打印元素原有的css属性
                //ignoreElements:[],//传入要打印的div中的子元素id，使其不打印。
                //style: '.img-rules { top: -150px;}'
            })
            //隐藏
            doc.style.display = "none";
            //console.log(doc.innerHTML)
            // setTimeout(function() {
            // }, 3000);

        },
        // setBodyHtml(html) {

        //     const document = window.document;
        //     const iframe = window.frames[0];
        //     iframe.document.head.innerHTML = document.head.innerHTML; // 获取当前文档的头部给iframe
        //     iframe.document.body.innerHTML = html; // 把传过来的html给iframe头部
        //     iframe.document.querySelectorAll('p').forEach(item => { item.style.fontSize = "12px", item.style.lineHeight = "23px" })
        //     iframe.document.querySelectorAll('.ivu-table-tbody span').forEach(item => { item.style.fontSize = "12px" })
        //     iframe.document.querySelectorAll('.ivu-table-summary .ivu-table-tbody span').forEach(item => { item.style.fontSize = "14px", item.style.fontWeight = "800" })
        //     iframe.document.querySelectorAll('h2').forEach(item => { item.style.lineHeight = "50px" })
        //     iframe.document.querySelectorAll('h3').forEach(item => { item.style.lineHeight = "40px" })
        //     iframe.document.querySelectorAll('h4').forEach(item => { item.style.lineHeight = "30px" })
        //     iframe.document.querySelectorAll('h5').forEach(item => { item.style.lineHeight = "30px" })
        //     iframe.document.querySelectorAll('h6').forEach(item => { item.style.lineHeight = "60px" })
        //     let imgRules = iframe.document.querySelector('.img-rules')
        //     console.log(imgRules)
        //     imgRules.style.height = "150px"
        //     imgRules.style.width = "150px"
        //     imgRules.style.position = "relative"
        //     imgRules.style.left = "50px"
        //     imgRules.style.bottom = "95px"
        //     // 图片和样式加载完成
        //     Promise.all([this.loadStyle(), this.loadImage()]).then(res => {
        //         //   打印
        //         iframe.window.print();
        //         // setTimeout(function() {  
        //         // }, 2000);

        //     });
        // },
        // loadStyle() {
        //     const iframe = window.frames[0];
        //     const styles = iframe.document.head.getElementsByTagName("style"); // <style>
        //     const links = iframe.document.head.getElementsByTagName("link"); // <link>
        //     let arrs = [];
        //     arrs = arrs.concat(...styles, ...links);

        //     return new Promise((resolve, reject) => {
        //         for (let i = 0; i < arrs.length; i++) {
        //             arrs[i].onload = function() {
        //                 if (i === arrs.length - 1) {
        //                     console.log("style 样式加载完成");
        //                     resolve("style 样式加载完成");
        //                 }
        //             };
        //         }
        //     });
        // },
        // loadImage() {
        //     const iframe = window.frames[0];
        //     const imgs = iframe.document.body.getElementsByTagName("img"); // <img>

        //     return new Promise((resolve, reject) => {
        //         for (let i = 0; i < imgs.length; i++) {
        //             imgs[i].onload = function() {
        //                 if (i === imgs.length - 1) {
        //                     console.log("img 加载完成");
        //                     resolve("img 加载完成");
        //                 }
        //             };
        //         }
        //     });
        // }

    }

}
</script>
<style lang="less" media="print">
#iframe {
    height: 600px;
    overflow: auto;
}

.logo {
    height: 13px;
    width: 13px;
    vertical-align: text-top;
}

.noprint {
    display: block;
}

@media print {
    .noprint {
        display: none;
    }

    .print {
        display: block;
    }
}
</style>